import React, { useState, useEffect, useRef } from "react";
import { DrawerItem } from "@progress/kendo-react-layout"
import { Button } from "@progress/kendo-react-buttons";
import { TextField } from '@mui/material';
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { Switch } from '@progress/kendo-react-inputs';
import { useDispatch, useSelector } from "react-redux";
import { setFilter, USER_FILTER } from "../../../store/actions/filterActions";
import { setDrawerClose } from "../../../store/actions/drawerActions";

export const UserDrawer = (props) => {
  const { groups } = useSelector(state => state.groupsReducer);
  const { userFilter } = useSelector(state => state.filterReducer);

  const dispatch = useDispatch();

  const [searchValue, setSearchValue] = useState(userFilter.searchValue);
  const [selectedGroups, setSelectedGroups] = useState(userFilter.selectedGroups);
  const [selectedSiteNames, setSelectedSiteNames] = useState(userFilter.selectedSiteNames);
  const [enabledFilter, setEnabledFilter] = useState(userFilter.enabledFilter);
  const [adminFilter, setAdminFilter] = useState(userFilter.adminFilter);
  const [showSearchClearBtn, setShowSearchClearBtn] = useState(userFilter.searchValue ? true : false);

  const firstRender = useRef(true);

  const siteArr = groups.map(g => { return { id: g.site.name, name: g.site.name } });

  const applyFilters = () => {
    dispatch(setFilter(USER_FILTER, {
      searchValue, selectedGroups, selectedSiteNames, enabledFilter, adminFilter
    }))
  }

  const clearFields = () => {
    setSearchValue('');
    setSelectedGroups([]);
    setSelectedSiteNames([]);
    setEnabledFilter(false);
    setAdminFilter(false);
    setShowSearchClearBtn(false);
  }

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
    } else {
      applyFilters();
    }
  }, [
    searchValue,
    selectedGroups,
    selectedSiteNames,
    enabledFilter,
    adminFilter
  ]);

  return (
    <DrawerItem style={{ height: '100%', flexDirection: 'column', backgroundColor: 'white' }} {...props}>
      <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
        <Button
          onClick={() => dispatch(setDrawerClose)}
          className='k-button k-primary k-flat'
          style={{ padding: 5 }}
        >
          <span className='k-icon k-i-close' />
        </Button>
        <span style={{ paddingLeft: 15, fontWeight: 'bold', fontSize: 18 }}>Filter Users</span>
      </div>
      <div style={styles.filterField}>
        <TextField
          autoFocus={true}
          variant={"standard"}
          label={"Search"}
          value={searchValue}
          onChange={(e) => {
            setSearchValue(e.target.value);
            setShowSearchClearBtn(e.target.value ? true : false);
          }}
          style={{ width: searchValue ? '88%' : '100%' }} />
        {showSearchClearBtn &&
          <div style={styles.clearButton}>
            <Button
              className="k-button k-primary"
              iconClass="k-icon k-i-close"
              onClick={() => {
                setSearchValue('');
                setShowSearchClearBtn(false);
              }}
            />
          </div>}
      </div>
      <div style={styles.filterField}>
        <MultiSelect
          className='drawer-multiselect'
          label={"Groups"}
          data={groups.map(g => { return { id: g.id, name: g.name } })}
          style={{ width: '100%' }}
          value={selectedGroups}
          onChange={(e) => setSelectedGroups(e.value)}
          textField="name"
          dataItemKey="id" />
      </div>
      <div style={styles.filterField}>
        <MultiSelect
          className='drawer-multiselect'
          label={"Sites"}
          data={siteArr.map(e => e['id'])
            .map((e, i, final) => final.indexOf(e) === i && i)
            .filter(obj=> siteArr[obj])
            .map(e => siteArr[e])}
          style={{ width: '100%' }}
          value={selectedSiteNames}
          onChange={(e) => setSelectedSiteNames(e.value)}
          textField="name"
          dataItemKey="id" />
      </div>
      <div style={styles.filterField}>
        <div style={{ ...styles.accountDiv, justifyContent: 'space-around', display: 'flex' }}>
          <div>
            <Switch
              checked={enabledFilter}
              onChange={() => setEnabledFilter(!enabledFilter)}
            />
            <label style={{ paddingLeft: '10px' }} className="k-checkbox-label">Enabled Users</label>
          </div>
          <div>
            <Switch
              checked={adminFilter}
              onChange={() => setAdminFilter(!adminFilter)}
            />
            <label style={{ paddingLeft: '10px' }} className="k-checkbox-label">Admin</label>
          </div>
        </div>
      </div>
      <Button
        className='k-button k-primary'
        style={{ width: '100%' }}
        onClick={() => clearFields()}>
        Reset Filter
      </Button>
    </DrawerItem>
  )
}

const styles = {
  filterField: {
    marginTop: 10,
    marginBottom: 25,
    width: '100%',
  },
  accountDiv: {
    backgroundColor: '#F5F5F5',
    padding: '8px',
    border: '2px solid #DCDCDC',
    borderRadius: '6px'
  },
  clearButton: {
    display: 'inline',
    paddingLeft: '8px',
    verticalAlign: 'bottom'
  },
}